import datapoints from '../datapoints';
import ConversationReadingPaneViewState from '../store/schema/ConversationReadingPaneViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint(
    'expandCollapsedItemsRollUp',
    datapoints.RPCountExpCollItemsRollUp
)(function expandCollapsedItemsRollUp(
    selectedConversationReadingPaneState: ConversationReadingPaneViewState,
    isAuto: boolean = false // This is used to track whether this expand is triggered by users action or auto expand
) {
    selectedConversationReadingPaneState.conversationNodeIdsInCollapsedItemsRollUp = [];
});
